export default __webpack_public_path__ + "static/media/no_videos.e3d6ecf8.svg";